import { SvgIconProps } from '../Icon';

const OfferFinancingIcon = ({ color, ...otherProps }: SvgIconProps): JSX.Element => (
  <svg viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...otherProps}>
    <path d="M3.78947 7.2H2.10526V12.8H3.78947V7.2ZM8.8421 7.2H7.1579V12.8H8.8421V7.2ZM16 14.4H0V16H16V14.4ZM13.8947 7.2H12.2105V12.8H13.8947V7.2ZM8 0L0 4V5.6H16V4L8 0Z" fill={color} />
  </svg>
);

export default OfferFinancingIcon;
